export const getHiringManagerName = (jobRole) => {
  if (jobRole.hiringManager) {
    return `${jobRole.hiringManager.firstName} ${jobRole.hiringManager.lastName}`;
  }
  return '';
};

export const filterJobRole = (jobRole, query) => {
  const lowerQuery = query.toLowerCase();
  return (
    jobRole.jobRoleData.title?.toLowerCase().includes(lowerQuery) ||
    jobRole.jobRoleData.requiredSkills?.some(skill =>
      skill.name?.toLowerCase().includes(lowerQuery)
    ) ||
    jobRole.jobRoleData.optionalSkills?.some(skill =>
      skill.name?.toLowerCase().includes(lowerQuery)
    ) ||
    jobRole.status?.toLowerCase().includes(lowerQuery) ||
    jobRole.company.company?.toLowerCase().includes(lowerQuery) ||
    getHiringManagerName(jobRole)?.toLowerCase().includes(lowerQuery) ||
    jobRole.formattedDate?.toLowerCase().includes(lowerQuery)
  );
};
